import { DetailedHTMLProps, IframeHTMLAttributes } from "react"
import { styled, SxProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import clsx from "clsx"

import { useSplitrPlayer } from "./hooks"

const IFrame = styled("iframe")(() => ({}))

export interface ISplitrPlayerProps
  extends DetailedHTMLProps<
    IframeHTMLAttributes<HTMLIFrameElement>,
    HTMLIFrameElement
  > {
  sx?: SxProps
  hidden?: boolean
  campaignId?: string | number
  deviceName?: string
}

export const SplitrPlayer: React.FC<ISplitrPlayerProps> = ({
  sx = {},
  hidden = false,
  campaignId,
  deviceName,
  ...props
}) => {
  const theme = useTheme()
  const { iframe } = theme.components[`SplitrPlayer`]?.styleOverrides || {}
  const { iframeOptions = {} } =
    theme.components[`SplitrPlayer`]?.defaultProps || {}
  const { sourceURL } = useSplitrPlayer({
    campaignId,
    deviceName,
  })

  return (
    <IFrame
      {...props}
      {...iframeOptions}
      className={clsx("SplitrPlayer-iframe", hidden ? "hidden" : "")}
      sx={deepmerge(iframe, sx)}
      src={sourceURL}
    />
  )
}
